export default __webpack_public_path__ + "static/media/AxionColliderBackground.7efcbc99.jpg";